<template>
  <MatrixView />
</template>

<script>
import { MatrixView } from "@shared/modules/work-allocation-matrix-admin/pages";

export default {
  components: {
    MatrixView,
  },
}
</script>

<style lang="scss" scoped />